import React, { Component } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { connect } from "react-redux";
import { compose } from "redux";
import { clearCart } from '../modules/actions';
import { getSchool, getisAuthenticated, getUserData } from '../modules/reducers';
class Thankyou extends Component {
    componentDidMount() {
        this.props.clearCart();
    } 
    viewOrders() {
        if(this.props.isAuthenticated)  {
            window.location.href = "myOrders";
        } else {
            window.location.href = "login";
        }
    }
    render() {
        const schoolPath = `school/${this.props.school.slug || this.props.school.name}`;
        return (
            <div className="site-wrap">
                <Header />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><a href={schoolPath}>Home</a> <span className="mx-2 mb-0">/</span> <strong className="text-black">Thank you</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <span className="icon-check_circle display-3 text-success" />
                                <h2 className="display-3 text-black">Thank you!</h2>
                                <p className="lead mb-2">You order was successfuly completed.</p>
                                <p className='lead mb-5'>To login and view status of order login with given email ID: {this.props.user.email}</p>
                                <p><a href={schoolPath} className="btn btn-sm btn-primary">Back to shop</a> | <button onClick={() => this.viewOrders()} className="btn btn-sm btn-primary">View Orders</button></p>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        school: getSchool(state),
        isAuthenticated: getisAuthenticated(state),
        user: getUserData(state),
    }
}

const mapDispatchToProps = dispatch => ({
    clearCart: () => dispatch(clearCart())
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Thankyou);
